import React from "react";

export type DocsIconProps = {
  cx?: string;
};

export const DocsIcon: React.FC<DocsIconProps> = ({ cx = "" }) => {
  return (
    <svg
      width="22"
      height="22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cx}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.937 7.453 13.78 4.297A.557.557 0 0 0 13.28 4H7.413A2.413 2.413 0 0 0 5 6.413v10.174A2.413 2.413 0 0 0 7.413 19h7.389a2.413 2.413 0 0 0 2.413-2.413V7.954a.556.556 0 0 0-.278-.501zm-3.082-1.522 1.448 1.43h-1.448V5.93zm2.246 10.656a1.3 1.3 0 0 1-1.3 1.3H7.414a1.3 1.3 0 0 1-1.3-1.3V6.413a1.3 1.3 0 0 1 1.3-1.3h5.328V7.75a.742.742 0 0 0 .743.743H16.1v8.094zm-7.555-7.07h1.8a.557.557 0 1 0 0-1.114h-1.8a.557.557 0 0 0 0 1.114zm-.394 1.872a.557.557 0 0 1 .394-.95h5.124a.557.557 0 1 1 0 1.113H8.546a.557.557 0 0 1-.394-.163zm5.518 1.096H8.546a.557.557 0 0 0 0 1.113h5.124a.557.557 0 0 0 0-1.114zm-5.124 2.039h5.124a.557.557 0 1 1 0 1.114H8.546a.557.557 0 0 1 0-1.114z"
        fill="#111"
        fillOpacity=".8"
      />
    </svg>
  );
};
